'use strict';

import angular from 'angular';

/**
 * Configuration des routes pour la page des applications mobiles
 */
export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('main.applications', {
        url: '/applications',
        templateUrl: 'app/applications/applications.html',
        controller: 'ApplicationsController'
      });
  }]);
